module.exports = __webpack_public_path__ + "fonts/langham.d6396c4b.ttf";